<template>
	<div>
		<ValidationObserver
			ref="observer"
			tag="form"
			class="items"
			@submit.prevent
		>
			<AppInput
				v-model="inputValue"
				color="none"
				size="full"
				style="width:100%"
				placeholder="Paste a link URL here"
				type="text"
				name="Link"
				:rules="{ required: true, url: true }"
				@submit="onSubmit"
			/>
			<AppButton
				color="outline-light"
				size="flex"
				item="icon"
				@click="pasteLink"
			>
				<img
					src="@/assets/paste.png"
					alt="paste"
				>
				Paste
			</AppButton>
		</ValidationObserver>
	</div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';

export default {
	name: 'LinkPasteInput',

	components: {
		ValidationObserver,
	},

	props: {
		value: {
			type: String,
			required: true,
		},
	},

	computed: {
		inputValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
	},

	watch: {
		async inputValue() {
			this.formIsValid = await this.$refs.observer.validate({ silent: true });
		},
	},

	methods: {
		async pasteLink() {
			this.inputValue = await navigator.clipboard.readText();
		},
		onSubmit() {
			this.$emit('submit');
		},
	},
};
</script>

<style lang="scss" scoped>
.items {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 2px solid $color-accent-400;
	transition: all 275ms ease-in-out;
	cursor: text;

	&:hover {
		border-bottom: 2px solid $color-accent-300;
	}
}

.section-description {
	font-size: $size-7;
	font-weight: $fontWeight-semibold;
	color: $color-accent-200;
	margin-top: $gap-2;
}
</style>
